import { HalfPregnant } from '../../../src/components'
import Footers from '../../../src/components/Footer'
import Header from '../../../src/components/Header'

export default function AccessibilityPage() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <HalfPregnant />
      </div>
      <Footers />
    </>
  )
}
